import { logRBIEvent } from 'features/analytics';
import { CustomEventNames, EventTypes } from 'features/analytics/constants';
import { IAmplitudeLoyaltyDocument } from 'features/analytics/types';

import { ICmsQuestCard } from 'components/quests/cms-hooks/types';
import { IQuest } from 'components/quests/loyalty-quest/types';

type QuestEventBase = {
  quest: IQuest;
  cmsQuestCard: ICmsQuestCard;
  attributes?: Record<string, any>;
};

export type ILogQuestEvent =
  | (QuestEventBase & { name: CustomEventNames.QUEST_DETAILS_VIEW })
  | (QuestEventBase & {
      name: CustomEventNames.QUEST_ACTIVATION_REQUESTED;
      attributes: Record<string, any> & { activationSource: string; loyaltyId?: string };
    });

export function getLoyaltyDocumentForQuest(
  quest: IQuest,
  cmsQuestCard: ICmsQuestCard
): IAmplitudeLoyaltyDocument {
  return {
    name: cmsQuestCard.name?.locale || '',
    sanityId: quest.cmsId,
    loyaltyEngineId: cmsQuestCard.loyaltyEngineId || '',
    type: quest.cmsType,
    ...(quest.incentiveType && { incentiveType: quest.incentiveType }),
    questStartDate: quest.startDate,
    questEndDate: quest.endDate,
  };
}

export const logQuestEvent = (
  event: ILogQuestEvent,
  logOptions?: { skipLoggingToBraze?: boolean }
) => {
  const { quest, cmsQuestCard, attributes = {} } = event;
  const eventAttributes = {
    questId: quest.id,
    ...getLoyaltyDocumentForQuest(quest, cmsQuestCard),
    ...attributes,
  };

  if (event.name === CustomEventNames.QUEST_ACTIVATION_REQUESTED) {
    logRBIEvent(
      {
        name: CustomEventNames.QUEST_ACTIVATION_REQUESTED,
        type: EventTypes.Other,
        attributes: { ...eventAttributes, activationSource: event.attributes.activationSource },
      },
      logOptions
    );
    return;
  }

  logRBIEvent(
    {
      name: CustomEventNames.QUEST_DETAILS_VIEW,
      type: EventTypes.Other,
      attributes: eventAttributes,
    },
    logOptions
  );
};
